import allStores from "../stores/StoreLoader";

export function sb_hideAllAdminNavModals(exceptModal) {
  if (exceptModal !== "editPage") {
    allStores.interfaceStore.stopEditingPage();
  }
}
